import AddInterpreter from 'components/interpreter/AddInterpreter';
import React, { useEffect } from 'react';
import FullPageLoader from 'components/common/FullPageLoader';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { interpreterSelector, getInterpreterById } from 'slices/interpreterSlice';

const InterpreterUpdate = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { id } = useParams();

    const { singleInterpreter, loader } = useSelector(interpreterSelector);

    useEffect(() => {
        if (id) {
            dispatch(getInterpreterById(id));
        }
    }, [dispatch, id]);

    if (loader) return <FullPageLoader />;

    if (!singleInterpreter) return <div>No interpreter found</div>;

    return (
        <div className='content'>
            <div className="row_main_head">
                <div className='d-flex align-items-center gap-2'>
                    <button className="main_heading back_button" onClick={() => navigate(-1)}>
                        <i className="fa-solid fa-arrow-left"></i> Back
                    </button>
                    <h2 className="main_heading">Update Accounts</h2>
                </div>
            </div>

            <AddInterpreter item={singleInterpreter} />
        </div>
    );
};

export default InterpreterUpdate;